module.exports = __webpack_public_path__ + "img/Popular_Forrest_Website_Small.e56b7ac6.jpg";